import React, { useContext, useMemo, useState } from 'react'
import { ThemeContext } from '../../../auth';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import Select from 'react-select';
import Swal from 'sweetalert2';
import axios from '../../../api/axios';

function ModalUbahRequest({
    meetingid,
    showEditRequest,
    setShowEditRequest,
    rowSelected,
    listUser,
    retrieveUser,
    retrieveAkun,
    retrieveDetailAkun,
    retrieveDetailMeeting,
    retrievePeserta,
    tokenUser
}) {

    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleClose = () => {
        setShowEditRequest(false);
    };

    const defaultValue = {
        nama_meeting: rowSelected?.nama_meeting || '',
        user: rowSelected?.user || '',
    };

    const userOptions = useMemo(() =>
        listUser.map(user => ({
            value: user?.id,
            label: user?.first_name + ' ' + user?.last_name,
        })),
        [listUser]
    );

    const handleSelectUser = (selectedOption, setFieldValue) => {
        setFieldValue('user', selectedOption ? selectedOption.value : "");
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? 'white' : '#222'
        },
        input: {
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            backgroundColor: theme === 'light' ? '#212529' : '#FFFFFF',
            color: theme === 'light' ? '#FFFFFF' : '#222'
        },
        button: {
            height: '50px',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    const handleSubmitRequest = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        try {

            await axios.patch(`/manage/requests/${meetingid}/`, values, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },
            });

            const dataNotification = {
                "user_id": values.user,
                "title": 'Pemberitahuan Meeting',
                "body": `${values.nama_meeting} \nTanggal: ${rowSelected?.waktu_mulai.split('T')[0]} \nWaktu: ${rowSelected?.waktu_mulai.split('T')[1].split(':').slice(0, 2).join(':')}`,
                "sound": "default",
                "data": {
                    "type": "reminder"
                }
            }

            const responseNotif = await axios.post(`/account/send-notification/`, dataNotification,
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        withCredentials: true,
                        Authorization: `Token ` + tokenUser,
                    },
                }
            );

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengubah request meeting',
                showConfirmButton: true,
            });

            retrieveUser();
            retrieveAkun();
            retrieveDetailAkun();
            retrieveDetailMeeting();
            retrievePeserta();

        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengubah request meeting',
            });
        } finally {
            setIsSubmitting(false);
            setDisabled(false);
        }
    };

    return (
        <Modal
            show={showEditRequest}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Ubah Meeting
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmitRequest}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        setFieldValue
                    }) => (
                        <Form
                            onSubmit={handleSubmit}
                        >
                            <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='meetingName'>Nama Meeting*</Form.Label>
                                <Form.Control
                                    id='meetingName'
                                    type='text'
                                    required
                                    value={values.nama_meeting}
                                    onChange={handleChange("nama_meeting")}
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='requestBy'>Permintaan Dari*</Form.Label>
                                <Select
                                    id='requestBy'
                                    required
                                    options={userOptions}
                                    value={userOptions.find(option => option.value === values.user) || null}
                                    onChange={(selectedOption) => handleSelectUser(selectedOption, setFieldValue)}
                                    styles={selectStyles}
                                    placeholder='Select...'
                                />
                            </Form.Group>
                            <div className="d-grid gap-2 mt-4">
                                {isSubmitting ? (
                                    <Button
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled
                                    >
                                        <Spinner
                                            animation="border"
                                            size='sm'
                                        />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled={disabled}
                                    >
                                        Simpan
                                    </Button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalUbahRequest
